<template>
  <div>
    <HomeDefault v-if="$store.state.app.match == null" />
    <HomeLiveMatch
      v-if="$store.state.app != null && $store.state.app.match != null && $store.state.app.match.status == 'live'"
    />
    <HomeAfterMatch
      v-if="$store.state.app != null && $store.state.app.match != null && $store.state.app.match.status == 'finished'"
    />
    <HomeMatchDay
      v-if="$store.state.app != null && $store.state.app.match != null && $store.state.app.match.status == 'waiting'"
    />
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import HomeDefault from "@/components/HomeDefault";
import HomeMatchDay from "@/components/HomeMatchDay";
import HomeAfterMatch from "@/components/HomeAfterMatch";
import HomeLiveMatch from "@/components/HomeLiveMatch";


export default {
  name: "Home",
  components: {
    Footer,
    Menu,
    Header,
    HomeDefault,
    HomeMatchDay,
    HomeAfterMatch,
    HomeLiveMatch
  },
  data() {
    return {};
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Home.vue